import NewCategory from './NewCategory'

export default NewCategory



// WEBPACK FOOTER //
// ./src/components/Categories/New/index.js